module.exports = __webpack_public_path__ + "img/memphis-02.a5a425b0.png";